import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class ClaimModuleList extends Component {
  renderStatus(status) {
    const map = {
      Draft: ["#F1F5F9", "#475569"],
      "Pending Approval": ["#FFF7E6", "#B76E00"],
      "Pending Finance": ["#FFF7E6", "#C2410C"],
      Approved: ["#ECFDF3", "#027A48"],
      Paid: ["#EAF8FB", "#027A7A"],
      Rejected: ["#FEECEC", "#B42318"],
    };

    const [bg, color] = map[status] || map.Draft;

    return (
      <span style={{ background: bg, color, padding: "5px 10px", borderRadius: 20, fontSize: 12, fontWeight: 800 }}>
        {status}
      </span>
    );
  }

  renderCard(label, value, sub, bg) {
    return (
      <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: 18 }}>
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: bg }} />
          <div>
            <div style={{ fontSize: 12, color: "#64748B", fontWeight: 800 }}>{label}</div>
            <div style={{ fontSize: 26, fontWeight: 900, color: "#0F172A" }}>{value}</div>
            <div style={{ fontSize: 12, color: "#64748B" }}>{sub}</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const rows = [
      ["CLM-2024-0187", "Lee Min Hao", "Operations", "Local Travel Claim", "TR-2024-0081", "20 May 2024, 09:15 AM", "1,250.00", "Pending Approval"],
      ["CLM-2024-0186", "Nurul Izzati Binti Rahman", "Human Resources", "Credit Card Claim", "CC-2024-0056", "19 May 2024, 04:32 PM", "2,890.45", "Pending Finance"],
      ["CLM-2024-0185", "Aiman Hakim Bin Saiful", "CRM & ICT", "Cash Claim", "-", "19 May 2024, 11:07 AM", "320.00", "Approved"],
      ["CLM-2024-0184", "Siti Nur Aisyah Binti Ahmad", "Data & Analytics", "Overseas Travel Claim", "TR-2024-0079", "18 May 2024, 03:21 PM", "5,680.00", "Paid"],
      ["CLM-2024-0183", "Muhammad Faris Bin Halim", "Marketing & Comms", "Meal Allowance", "-", "18 May 2024, 10:45 AM", "180.00", "Draft"],
      ["CLM-2024-0182", "Izzah Maisarah Binti Kamal", "Procurement", "Mileage Claim", "-", "17 May 2024, 09:30 AM", "145.60", "Rejected"],
    ];

    return (
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 22 }}>
          <div>
            <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>Claim Module</h4>
            <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
              Manage employee claims from submission to payment.
            </p>
          </div>

          <Link to="/claim/create" style={primaryButton}>
            + Create Claim
          </Link>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 14, marginBottom: 22 }}>
          {this.renderCard("Draft", 18, "Not submitted", "#EEF4FF")}
          {this.renderCard("Pending Approval", 26, "Awaiting approver", "#FFF7E6")}
          {this.renderCard("Pending Finance", 14, "Awaiting finance review", "#FFF7E6")}
          {this.renderCard("Approved", 37, "Approved", "#ECFDF3")}
          {this.renderCard("Paid", 102, "Paid to employee", "#EAF8FB")}
          {this.renderCard("Rejected", 7, "Returned / Rejected", "#FEECEC")}
        </div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1.4fr auto", gap: 12, padding: 16 }}>
            <input placeholder="Search claims..." style={inputStyle} />
            <select style={inputStyle}><option>All Claim Types</option></select>
            <select style={inputStyle}><option>All Departments</option></select>
            <select style={inputStyle}><option>All Statuses</option></select>
            <input value="01 May 2024 - 31 May 2024" readOnly style={inputStyle} />
            <button style={secondaryButton}>Filters</button>
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#F8FAFC", fontSize: 12, color: "#475569" }}>
                {["Claim ID", "Employee", "Department", "Claim Type", "Related Trip / Ref", "Submitted Date", "Amount (RM)", "Status", "Action"].map((h) => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row) => (
                <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                  <td style={tdStyle}>
                    <Link to={`/claim/${row[0]}`} style={{ color: theme.colors.brand.primary || "#002B5B", fontWeight: 900 }}>
                      {row[0]}
                    </Link>
                  </td>
                  <td style={tdStyle}>{row[1]}</td>
                  <td style={tdStyle}>{row[2]}</td>
                  <td style={tdStyle}>{row[3]}</td>
                  <td style={tdStyle}>{row[4]}</td>
                  <td style={tdStyle}>{row[5]}</td>
                  <td style={tdStyle}>{row[6]}</td>
                  <td style={tdStyle}>{this.renderStatus(row[7])}</td>
                  <td style={tdStyle}>•••</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ padding: 16, color: "#64748B", fontSize: 12 }}>
            Showing 1 to 6 of 74 entries
          </div>
        </div>
      </div>
    );
  }
}

const inputStyle = {
  height: 38,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 900,
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "14px",
  fontSize: 13,
  color: "#334155",
  verticalAlign: "middle",
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  padding: "10px 16px",
  borderRadius: 8,
  textDecoration: "none",
  fontWeight: 900,
  fontSize: 13,
  height: 40,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 800,
  cursor: "pointer",
};

export default ClaimModuleList;